import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { PREFIX } from './../interfaces/Prefix.interface';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  TrnMain,
  TrnProd,
  Trntran,
  TSubLedger,
  TSubLedgerTran,
  CostCenter,
  VoucherTypeEnum,
} from './../interfaces/TrnMain';
import { TAcList } from './../interfaces/Account.interface';
import { MasterRepo } from './../repositories/masterRepo.service';
import { Observable } from 'rxjs';
import { Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransactionService } from './transaction.service';
import { SettingService } from './../services/setting.service';

@Component({
  selector: 'trntran-voucher-entry',
  templateUrl: './trntran-voucher-entry.component.html',
  providers: [],
  styles: [
    `
      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
      }

      input,
      select,
      textarea {
        border: 1px solid #cbcbcb;
        border-radius: 3px;
        height: 23px;
        color: black;
      }

      tr td {
        border-top: 0px;
        border-bottom: 0px;
        line-height: 31px;
        padding: 0px 2px;
      }
      tr th {
        line-height: 31px;
        padding: 0px;
        padding-left: 4px;
        padding-right: 4px;
      }
      tbody {
        border-top: 0px;
      }
      tbody:hover {
        background-color: #e0e0e0;
      }
      tr {
        padding-left: 4px;
        padding-right: 4px;
      }
    `,
  ],
})
export class TrnTranVoucherEntryComponent {
  selectedtrntranRowIndex: number = 0;
  hideSubledger: boolean = true;
  TrnMainObj: TrnMain = <TrnMain>{};
  TrnTranList: Trntran[] = [];
  trnaccountList!: Observable<TAcList[]>;
  subledgers: TSubLedgerTran[] = [];
  subledgerDropDownList: TSubLedger[] = [];
  costCenterList: CostCenter[] = [];
  subLedgerTotal: number = 0;
  trntranTotal: number = 0;
  voucherType!: VoucherTypeEnum;
  viewMode = false;
  showHelp = true;
  hideSubledgerList = true;
  showWholeSubLedger = true;
  addFocus = false;
  @ViewChild('myInput') input!: ElementRef;

  TranForm!: FormGroup;
  constructor(
    public masterService: MasterRepo,
    public _transactionService: TransactionService,
    private settingService: SettingService,
    private router: Router,
    private arouter: ActivatedRoute,
    private fb: FormBuilder,
    private renderer: Renderer2
  ) {
    try {
      this.masterService.refreshTransactionList();
      this.showWholeSubLedger =
        this.settingService.appSetting.enableSubLedger || false;
      this.TrnMainObj = this._transactionService.TrnMainObj;
      this.TrnTranList = this.TrnMainObj.TrntranList = [];
      this.voucherType = this.TrnMainObj.VoucherType;
      this.trnaccountList = this._transactionService.accountListObersver$;
      if (this.TrnTranList.length == 0) {
        this.AddNewTrnTranRow();
      }

      /*
            this.TranForm = fb.group({
                tranlist:this.fb.array([])
            })*/
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  ngOnInit() {
    try {
      this.masterService.getSubLedgerList().subscribe(
        (res) => {
          this.subledgerDropDownList = res;
        },
        (error) => {
          this.masterService.resolveError(
            error,
            'AddIncomeVoucher - getSubLedgerList'
          );
        }
      );

      if (this.TrnMainObj.Mode == 'VIEW') {
        this.viewMode = true;
      }

      if (this.TrnMainObj.Mode == 'EDIT' || this.TrnMainObj.Mode == 'VIEW') {
        this._transactionService.loadDataObservable.subscribe((data) => {
          try {
            this.TrnTranList = data.TrntranList;
            this.TrnTranList.forEach((t) => {
              t.ROWMODE = 'save';
              t.AccountItem = this.masterService.accountList.filter(
                (y) => y.ACID == t.A_ACID
              )[0];
              t.acitem = t.AccountItem;
              this.LoadSubledgerForTran(t);
              console.log({ trntranlist: t });
            });
            if (this.viewMode == false) {
              var nulltt = <Trntran>{};
              nulltt.AccountItem = <TAcList>{};
              nulltt.ROWMODE = 'new';
              this.TrnTranList.push(nulltt);
            }
          } catch (e) {
            console.log({ errorOnLoad: e });
          }
        });
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  LoadSubledgerForTran(t: Trntran) {
    try {
      if (
        t.AccountItem != null &&
        t.AccountItem &&
        t.AccountItem.HASSUBLEDGER == 1
      ) {
        t.SubledgerTranList.forEach((z) => {
          (z.ROWMODE = 'save'),
            (z.SubledgerItem = this.subledgerDropDownList.filter(
              (w) => w.ACID == z.A_ACID
            )[0]);
        });
        if (this.viewMode == false) {
          this.addTrnTranRow();
        }
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  accountListObservable$ = (keyword: any): Observable<TAcList[]> => {
    return new Observable((observer: Subscriber<TAcList[]>) => {
      if (keyword) {
        this.trnaccountList
          .pipe(
            map((data: any) => {
              console.log({ accountlistobservable: 'before toupper' });
              var lst = data.filter(
                (ac: any) =>
                  ac.ACNAME.toUpperCase().indexOf(keyword.toUpperCase()) > -1
              );
              console.log({ keyword: keyword, filter: lst, data: data });
              return lst;
            })
          )
          .subscribe((res: any) => {
            console.log({
              keyword: keyword,
              filterSubscribe: res,
              data: res,
            });
            observer.next(res);
          });
      } else {
        observer.next([]);
        console.log({ keyword: keyword, filter: 'empty' });
      }
    });
  };

  AddNewTrnTranRow() {
    try {
      var nulltt = <Trntran>{};
      nulltt.AccountItem = <TAcList>{};
      nulltt.ROWMODE = 'new';
      this.TrnTranList.push(nulltt);
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  AddNewSubLedgerRow() {
    try {
      var nullsl = <TSubLedgerTran>{};
      nullsl.SubledgerItem = <TSubLedger>{};
      nullsl.ROWMODE = 'new';
      this.subledgers.push(nullsl);
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  TrnTranRowOk(index: any) {
    try {
      this.addFocus = true;
      var rm = this.TrnTranList[index].ROWMODE;
      if (rm == 'new') {
        this.TrnTranList[index].ROWMODE = 'save';
        this.AddNewTrnTranRow();
      } else if (rm == 'edit') {
        this.TrnTranList[index].ROWMODE = 'save';
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  SubLedgerRowOk(index: any) {
    try {
      var rm = this.subledgers[index].ROWMODE;
      if (rm == 'new') {
        this.subledgers[index].ROWMODE = 'save';
        this.AddNewSubLedgerRow();
      } else if (rm == 'edit') {
        this.subledgers[index].ROWMODE = 'save';
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  clearRow(index: any) {
    try {
      var rm = this.TrnTranList[index].ROWMODE;
      if (rm == 'new') {
        this.TrnTranList[index] = <Trntran>{};
        this.TrnTranList[index].AccountItem = <TAcList>{};
        this.TrnTranList[index].ROWMODE = 'new';
      } else if (rm == 'save' || rm == 'edit') {
        this.TrnTranList.splice(index, 1);
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  clearSubLedgerRow(index: any) {
    try {
      var rm = this.subledgers[index].ROWMODE;
      if (rm == 'new') {
        this.subledgers[index] = <TSubLedgerTran>{};
        this.subledgers[index].SubledgerItem = <TSubLedger>{};
        this.subledgers[index].ROWMODE = 'new';
      } else if (rm == 'save' || rm == 'edit') {
        this.subledgers.splice(index, 1);
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  editRow(index: any) {
    try {
      if (this.TrnTranList[index].ROWMODE == 'save') {
        this.TrnTranList[index].ROWMODE = 'edit';
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  editSubledgerRow(index: any) {
    try {
      if (this.subledgers[index].ROWMODE == 'save') {
        this.subledgers[index].ROWMODE = 'edit';
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  trnAccountChange(hasSubLedger: any, index: any) {
    try {
      this.selectedtrntranRowIndex = index;
      this.TrnTranList[index].CRAMNT = 0;
      this.TrnTranList[index].DRAMNT = 0;
      if (hasSubLedger == 1) {
        this.showSubLedgerEntry(index);
        if (
          this.voucherType == VoucherTypeEnum.PaymentVoucher ||
          this.voucherType == VoucherTypeEnum.CreditNote
        ) {
          this.subLedgerCrAmtChanges();
        } else if (
          this.voucherType == VoucherTypeEnum.ReceiveVoucher ||
          this.voucherType == VoucherTypeEnum.DebitNote
        ) {
          this.subLedgerDrAmtChanges();
        }
      } else {
        this.hideSubLedgerEntry(index);
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  hideSubLedgerEntry(index: any) {
    try {
      this.hideSubledger = true;
      this.subledgers = [];
      if (this.TrnTranList[index].ROWMODE == 'new') {
        this.showHelp = true;
        this.hideSubledgerList = true;
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  showSubLedgerEntry(index: any) {
    try {
      if (this.TrnTranList[index].SubledgerTranList == null) {
        this.TrnTranList[index].SubledgerTranList = [];
      }
      if (this.TrnTranList[index].SubledgerTranList.length == 0) {
        this.AddNewSubLedgerRow();
        this.TrnTranList[index].SubledgerTranList = this.subledgers;
      }
      this.subledgers = this.TrnTranList[index].SubledgerTranList;
      for (var i in this.subledgers) {
        if (
          this.subledgers[i].SubledgerItem != null &&
          this.subledgers[i].SubledgerItem.ACNAME != null &&
          this.subledgers[i].Amount != null &&
          this.subledgers[i].Amount > 0
        ) {
          this.subledgers[i].ROWMODE = 'save';
        }
      }
      this.hideSubledger = false;
      this.hideSubledgerList = true;
      this.showHelp = false;
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  rowClick(i: any) {
    try {
      this.showHelp = false;
      this.hideSubledgerList = false;
      this.selectedtrntranRowIndex = i;
      if (this.TrnTranList[i].AccountItem == null) {
        console.log('return');
        return;
      }
      if (
        this.TrnTranList[i].AccountItem &&
        this.TrnTranList[i].AccountItem.HASSUBLEDGER == 1
      ) {
        this.showSubLedgerEntry(i);
        if (
          this.voucherType == VoucherTypeEnum.PaymentVoucher ||
          this.voucherType == VoucherTypeEnum.CreditNote
        ) {
          this.subLedgerCrAmtChanges();
        } else if (
          this.voucherType == VoucherTypeEnum.ReceiveVoucher ||
          this.voucherType == VoucherTypeEnum.DebitNote
        ) {
          this.subLedgerDrAmtChanges();
        }
      } else {
        this.hideSubLedgerEntry(i);
      }

      // if(this.TrnTranList[i].ROWMODE == "new"){
      //     this.showHelp = true;
      //     this.hideSubledgerList = true;
      // }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  addTrnTranRow() {}
  subLedgerDrAmtChanges() {
    try {
      this.subLedgerTotal = 0;
      this.subledgers.forEach((x) => {
        this.subLedgerTotal += x.DRAMNT == null ? 0 : x.DRAMNT;
      });
      this.TrnTranList[this.selectedtrntranRowIndex].CRAMNT =
        this.subLedgerTotal;
      this.TrnTranCrAmtChange(null);
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  subLedgerCrAmtChanges() {
    try {
      this.subLedgerTotal = 0;
      this.subledgers.forEach((x) => {
        this.subLedgerTotal += x.CRAMNT == null ? 0 : x.CRAMNT;
      });
      this.TrnTranList[this.selectedtrntranRowIndex].DRAMNT =
        this.subLedgerTotal;
      this.TrnTranDrAmtChange(null);
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  TrnTranDrAmtChange(value: any) {
    try {
      this.trntranTotal = 0;
      this.TrnTranList.forEach((x) => {
        this.trntranTotal += x.DRAMNT == null ? 0 : x.DRAMNT;
      });
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  TrnTranCrAmtChange(value: any) {
    try {
      this.trntranTotal = 0;
      this.TrnTranList.forEach((x: any) => {
        this.trntranTotal += x.CRAMNT == null ? 0 : x.CRAMNT;
      });
    } catch (ex: any) {
      console.log(ex);
      alert(ex);
    }
  }

  AutoSelectAcnameChange($event: any, index: any) {
    try {
      if (typeof $event == 'object') {
        var ac = <TAcList>$event;
        this.TrnTranList[index].AccountItem = $event;
        this.TrnTranList[index].AccountItem.ACCODE = ac.ACCODE;
        // if (ac.HASSUBLEDGER == 1) {
        //     this.showSubLedgerEntry(index);
        // } else {
        //     this.hideSubLedgerEntry(index);
        //     this.TrnTranList[index].SubledgerTranList = [];
        // }
      } else {
        this.TrnTranList[index].AccountItem.ACCODE = '';
      }
    } catch (error) {
      this.TrnTranList[index].AccountItem.ACCODE = '';
    }
  }
}
